import ReactDOM from "react-dom/client";
import { AppComponent } from "./components/AppComponent";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <AppComponent
      style={{
        flex: 1,
        border: "none",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
        zIndex: "40",
        maxHeight: "100dvh",
        height: "100dvh",
        display: "flex", // Initially hidden
      }}
    />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
